// extracted by mini-css-extract-plugin
export var authorCard = "T_cX";
export var authorCardContent = "T_cZ";
export var authorCardImage = "T_cY";
export var bottom = "T_c4";
export var description = "T_c3";
export var name = "T_c1";
export var role = "T_c2";
export var top = "T_c0";